import React, {Component} from 'react';
import withStore from "../hoc/withStore";
import styled from 'styled-components';
import {connect} from "react-redux";
import {selectSearchQuery, selectSearchResult} from "../store/search/selectors";
import {changeSearchQuery} from "../store/search/actions";
import withImmutablePropsToJS from 'with-immutable-props-to-js'
import OutsideClickDetector from "../elements/OutsideClickDetector";
import SearchSection from "./SearchSection";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSearch} from '@fortawesome/pro-solid-svg-icons/faSearch';


const Input = styled.input`
${props => props.opened ? `
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
` : ''}
`;

const Form = styled.form`
    height: 35px;
`;

const DropdownWrapper = styled.div`
    transition: all 250ms ease-in-out;
`;

class SearchBox extends Component {

    state = {
        focused: false,
        index: 0,
    };

    onChangeQuery = (e) => {
        const {changeSearchQuery} = this.props;
        changeSearchQuery(e.target.value);
    };

    focus = () => {
        this.setState({
            focused: true,
        });
    };

    blur = () => {
        this.setState({
            focused: false,
        });
    };

    submit = (e) => {
        const {index} = this.state;

        if (index > 0) {
            window.location = this.getSelectedURL();

            e.preventDefault();
            return false;
        }
        
        if (this.props.query.length < 3) {
            e.preventDefault();
            return false;
        }
    };

    onKeyDown = (e) => {
        const {index} = this.state;
        const {results} = this.props;
        const maxCount = results?.Categories?.length + results?.Products?.length + 1;

        if (e.key === 'ArrowDown') {
            this.setState({
                index: (this.state.index + 1) % maxCount,
            });
            e.preventDefault();
        } else if (e.key === 'ArrowUp') {
            this.setState({
                index: (this.state.index - 1 + maxCount) % maxCount,
            });
            e.preventDefault();
        } else if(index > 0 && e.key !== 'Enter') {
            this.setState({
                index: 0,
            });
        }

        // e.target.value += e.key;
        return true;
    };

    setIndex = (index) => {
        this.setState({
            index,
        });
    };

    getSelectedName = () => {
        const {results} = this.props;
        const {index} = this.state;

        return index < (results.Categories.length + 1) ?
            results.Categories[index - 1].CategoryName :
            results.Products[index - 1 - results.Categories.length].Name;
    };

    getSelectedURL = () => {
        const {results} = this.props;
        const {index} = this.state;

        return index < (results.Categories.length + 1) ?
            results.Categories[index - 1].SlugURL :
            results.Products[index - 1 - results.Categories.length].Slug;
    };
    mouseLeaveHandler = () => {
        this.setState({
            index: 0,
        });
        this.focus();
    };
    render() {
        const {action, label, placeholder, tooltip, query, results, topCategoriesTitle, topProductsTitle} = this.props;
        const {focused, index} = this.state;
        const hasResults = results && (results.Categories.length + results.Products.length) > 0;
        const opened = query.length >= 3 && focused && hasResults;
        return <Form action={action} method="get" onSubmit={this.submit}>
            <DropdownWrapper className={`position-relative rounded zindex-1000 ${opened ? 'shadow' : ''}`}>
                <OutsideClickDetector
                    onClick={this.focus}
                    onClickOutside={this.blur}
                    className="position-relative">
                    <Input type="text"
                           className={`form-control pr-5 border shadow-none`}
                           opened={opened}
                           autoComplete="off"
                           autoCorrect="off" 
                           autoCapitalize="off" 
                           spellCheck="false"
                           name="q"
                           placeholder={placeholder}
                           aria-label={label}
                           value={query}
                           onChange={this.onChangeQuery}
                           onFocus={this.focus}
                           onKeyDown={this.onKeyDown}/>
                    <button type="submit"
                            className="position-absolute top right border-0 bg-transparent h-100 p-0 w-p40"
                            value="Search" aria-label={tooltip}>
                        <FontAwesomeIcon icon={faSearch} />
                    </button>
                </OutsideClickDetector>
                {opened &&
                <div
                    className="bg-white border-left border-right border-bottom rounded-bottom position-relative zindex-7000 px-2 py-1"
                    onMouseLeave={ this.mouseLeaveHandler }>
                    <SearchSection title={topCategoriesTitle}
                                   selectedIndex={index - 1}
                                   onHover={(index) => this.setIndex(index + 1)}
                                   items={results.Categories.map(category => ({
                                       id: category.CategoryId,
                                       name: category.CategoryName,
                                       slug: category.SlugURL,
                                   }))}/>
                    <SearchSection title={topProductsTitle}
                                   selectedIndex={index - 1 - results.Categories.length}
                                   onHover={(index) => this.setIndex(index + 1 + results.Categories.length)}
                                   items={results.Products.map(product => ({
                                       id: product.ProductId,
                                       name: product.Name,
                                       slug: product.Slug,
                                   }))}/>
                </div>}
            </DropdownWrapper>
        </Form>
    }
}

const mapStateToProps = state => ({
    query: selectSearchQuery(state),
    results: selectSearchResult(state),
});

const mapDispatchToProps = dispatch => ({
    changeSearchQuery: (query) => dispatch(changeSearchQuery(query)),
});

export default withStore(connect(mapStateToProps, mapDispatchToProps)(withImmutablePropsToJS(SearchBox)));